class TipoAlteracaoEnum {
  constructor() {
    this.FRETE_EMPRESA = 'FRETE_EMPRESA';
    this.SUSPENDER = 'SUSPENDER';
    this.RETOMAR = 'RETOMAR';
    this.FINALIZAR = 'FINALIZAR';
    this.LIVRE_CONCORRENCIA = 'LIVRE_CONCORRENCIA';
  }
}

export default new TipoAlteracaoEnum();
